import { Vue } from 'vue-property-decorator';

export default class Base extends Vue {
  localize(en: string, nl: string) {
    return this.$route.params.lang === "nl" ? nl : en;
  }
}